var _feFlood, _feComposite, _feGaussianBlur, _feOffset, _feComposite2, _feFlood2, _feComposite3, _feGaussianBlur2, _feOffset2, _feComposite4, _feFlood3, _feComposite5, _feGaussianBlur3, _feOffset3, _feComposite6, _feFlood4, _feComposite7, _feGaussianBlur4, _feOffset4, _feComposite8, _feColorMatrix, _feFlood5, _feComposite9, _feGaussianBlur5, _feOffset5, _feComposite10, _feFlood6, _feComposite11, _feGaussianBlur6, _feOffset6, _feComposite12, _feColorMatrix2, _feFlood7, _feComposite13, _feGaussianBlur7, _feOffset7, _feComposite14, _feFlood8, _feComposite15, _feGaussianBlur8, _feOffset8, _feComposite16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNodeDeviceKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 194.625,
    height: 93,
    viewBox: "0 0 109.84477 34.263166",
    id: "svg3805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs3800"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter4374"
  }, _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood4364"
  })), _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite4366"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 2,
    result: "blur",
    id: "feGaussianBlur4368"
  })), _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "offset",
    id: "feOffset4370"
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "composite2",
    id: "feComposite4372"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter4374-3"
  }, _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood4364-7"
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite4366-5"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 2,
    result: "blur",
    id: "feGaussianBlur4368-9"
  })), _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "offset",
    id: "feOffset4370-2"
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "composite2",
    id: "feComposite4372-2"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter4374-9"
  }, _feFlood3 || (_feFlood3 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood4364-73"
  })), _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite4366-6"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 2,
    result: "blur",
    id: "feGaussianBlur4368-1"
  })), _feOffset3 || (_feOffset3 = /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    result: "offset",
    id: "feOffset4370-29"
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "composite2",
    id: "feComposite4372-3"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter4830"
  }, _feFlood4 || (_feFlood4 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood4820"
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite4822"
  })), _feGaussianBlur4 || (_feGaussianBlur4 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 1.8,
    result: "blur",
    id: "feGaussianBlur4824"
  })), _feOffset4 || (_feOffset4 = /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: -0.1,
    result: "offset",
    id: "feOffset4826"
  })), _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "fbSourceGraphic",
    id: "feComposite4828"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix8694"
  })), _feFlood5 || (_feFlood5 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood8696",
    floodOpacity: 1,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    in: "fbSourceGraphic"
  })), _feComposite9 || (_feComposite9 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "fbSourceGraphic",
    id: "feComposite8698",
    in: "flood",
    operator: "in",
    result: "composite1"
  })), _feGaussianBlur5 || (_feGaussianBlur5 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur8700",
    in: "composite1",
    stdDeviation: 0.1,
    result: "blur"
  })), _feOffset5 || (_feOffset5 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset8702",
    dx: 0,
    dy: 0,
    result: "offset"
  })), _feComposite10 || (_feComposite10 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "offset",
    id: "feComposite8704",
    in: "fbSourceGraphic",
    operator: "over",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter8848"
  }, _feFlood6 || (_feFlood6 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(0,0,0)",
    result: "flood",
    id: "feFlood8838"
  })), _feComposite11 || (_feComposite11 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite8840"
  })), _feGaussianBlur6 || (_feGaussianBlur6 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 1,
    result: "blur",
    id: "feGaussianBlur8842"
  })), _feOffset6 || (_feOffset6 = /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: -0.1,
    result: "offset",
    id: "feOffset8844"
  })), _feComposite12 || (_feComposite12 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "fbSourceGraphic",
    id: "feComposite8846"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0",
    id: "feColorMatrix8874"
  })), _feFlood7 || (_feFlood7 = /*#__PURE__*/React.createElement("feFlood", {
    id: "feFlood8876",
    floodOpacity: 1,
    floodColor: "rgb(63,63,63)",
    result: "flood",
    in: "fbSourceGraphic"
  })), _feComposite13 || (_feComposite13 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "fbSourceGraphic",
    id: "feComposite8878",
    in: "flood",
    operator: "in",
    result: "composite1"
  })), _feGaussianBlur7 || (_feGaussianBlur7 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "feGaussianBlur8880",
    in: "composite1",
    stdDeviation: 2,
    result: "blur"
  })), _feOffset7 || (_feOffset7 = /*#__PURE__*/React.createElement("feOffset", {
    id: "feOffset8882",
    dx: -0.1,
    dy: -0.1,
    result: "offset"
  })), _feComposite14 || (_feComposite14 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "offset",
    id: "feComposite8884",
    in: "fbSourceGraphic",
    operator: "over",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter9033"
  }, _feFlood8 || (_feFlood8 = /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "rgb(63,63,63)",
    result: "flood",
    id: "feFlood9023"
  })), _feComposite15 || (_feComposite15 = /*#__PURE__*/React.createElement("feComposite", {
    in: "flood",
    in2: "SourceGraphic",
    operator: "in",
    result: "composite1",
    id: "feComposite9025"
  })), _feGaussianBlur8 || (_feGaussianBlur8 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "composite1",
    stdDeviation: 1,
    result: "blur",
    id: "feGaussianBlur9027"
  })), _feOffset8 || (_feOffset8 = /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: -0.1,
    result: "offset",
    id: "feOffset9029"
  })), _feComposite16 || (_feComposite16 = /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic",
    in2: "offset",
    operator: "over",
    result: "composite2",
    id: "feComposite9031"
  })))), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#d5d5d5",
      fillOpacity: 1,
      stroke: "#010000",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.87830685,
      paintOrder: "stroke fill markers",
      filter: "url(#filter9033)"
    },
    id: "rect3807",
    width: 56.989555,
    height: 34.506004,
    x: 1.4912233,
    y: -4.7474341,
    rx: 0.93072182,
    ry: 1.0085174,
    transform: "matrix(1.7834772,0,0,1.1242408,2.4849164,3.7023742)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#010000",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0.87830685,
      paintOrder: "stroke fill markers"
    },
    id: "rect3807-9",
    width: 97.609734,
    height: 35.528645,
    x: 7.0926456,
    y: -0.35982051,
    rx: 1.5941081,
    ry: 1.0384064
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "28.21594238px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    x: 51.514923,
    y: 6.3218012,
    id: "text995-4"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan993-7",
    x: 51.514923,
    y: 6.3218012,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 600,
      fontStretch: "normal",
      fontSize: "5.643188px",
      fontFamily: "Crossten",
      InkscapeFontSpecification: "'Crossten Semi-Bold'",
      strokeWidth: 0.7053985
    }
  }, "Key")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#061e37",
      strokeWidth: 0.58783221,
      shapeRendering: "geometricPrecision"
    },
    id: "path6096-7-0",
    d: "m 93.730268,24.638946 v 5.130163 h 5.130174 v -5.130163 z m -0.641272,-0.961921 h 6.412714 c 0.177084,0 0.320647,0.143435 0.320647,0.320649 v 6.412705 c 0,0.177027 -0.143573,0.32065 -0.320647,0.32065 h -6.412714 c -0.177079,0 -0.320631,-0.143709 -0.320631,-0.32065 v -6.412705 c 0,-0.177026 0.143535,-0.320649 0.320631,-0.320649 z m 4.381768,3.532122 c 0.06166,0.03413 0.09672,0.08718 0.105312,0.158897 0.0085,0.07173 -0.01273,0.133311 -0.0642,0.184758 l -1.607816,1.518543 c -0.03768,0.0376 -0.08562,0.05652 -0.143829,0.05652 -0.07534,0 -0.134389,-0.03253 -0.177214,-0.09757 -0.04284,-0.06505 -0.0505,-0.131693 -0.02319,-0.199954 l 0.462312,-1.108127 -0.904073,-0.523298 c -0.05821,-0.03413 -0.09246,-0.08718 -0.102727,-0.159157 -0.0101,-0.07173 0.0101,-0.133311 0.06166,-0.184759 l 1.607864,-1.518516 c 0.04448,-0.0376 0.09246,-0.05652 0.14383,-0.05652 0.05819,0 0.108711,0.02134 0.151538,0.06399 0.04282,0.04292 0.0642,0.09332 0.0642,0.151433 0,0.03413 -0.007,0.06505 -0.02054,0.09252 l -0.457156,1.097867 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#061e37",
      strokeWidth: 0.58786756,
      shapeRendering: "geometricPrecision"
    },
    d: "m 96.064884,15.072433 0.680217,0.680169 h 2.526337 c 0.177104,0 0.320647,0.143434 0.320647,0.320542 v 2.885918 c 0,0.177295 -0.143563,0.320543 -0.320647,0.320543 h -2.885902 c -0.177108,0 -0.320636,-0.143435 -0.320636,-0.320543 v -2.526344 l -0.680219,-0.680116 h -2.526349 c -0.177107,0 -0.320651,-0.143433 -0.320651,-0.320516 v -2.885945 c 0,-0.177026 0.143533,-0.320514 0.320651,-0.320514 h 2.885899 c 0.17708,0 0.320653,0.143433 0.320653,0.320514 z m -2.565239,-1.885074 v 1.603296 h 1.603272 v -1.603296 z m 3.527204,3.527216 v 1.603243 h 1.603274 v -1.603243 z",
    id: "path3857-5-6"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.70265722px",
      lineHeight: 1.25,
      fontFamily: "Crossten",
      InkscapeFontSpecification: "Crossten",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#061e37",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    x: 71.296318,
    y: 17.84239,
    id: "text1803-3"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1801-20",
    x: 71.296318,
    y: 17.84239,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 600,
      fontStretch: "normal",
      fontSize: "5.643188px",
      fontFamily: "Crossten",
      InkscapeFontSpecification: "'Crossten Semi-Bold'",
      fill: "#061e37",
      fillOpacity: 1,
      strokeWidth: 0.7053985
    }
  }, "Node ")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.70265722px",
      lineHeight: 1.25,
      fontFamily: "Crossten",
      InkscapeFontSpecification: "Crossten",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    x: 48.882328,
    y: 42.256355,
    id: "text1803-6-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1801-2-1",
    x: 48.882328,
    y: 42.256355,
    style: {
      fontSize: "5.643188px",
      fill: "#3f3f3f",
      fillOpacity: 1,
      strokeWidth: 0.7053985
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.70265722px",
      lineHeight: 1.25,
      fontFamily: "Crossten",
      InkscapeFontSpecification: "Crossten",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    x: 45.655125,
    y: 53.507797,
    id: "text1803-6-2-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1801-2-7-5",
    x: 45.655125,
    y: 53.507797,
    style: {
      fontSize: "5.643188px",
      fill: "#3f3f3f",
      fillOpacity: 1,
      strokeWidth: 0.7053985
    }
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "4.70265722px",
      lineHeight: 1.25,
      fontFamily: "Crossten",
      InkscapeFontSpecification: "Crossten",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#061e37",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.7053985
    },
    x: 68.734848,
    y: 28.262196,
    id: "text1803-0-4"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1801-9-7",
    x: 68.734848,
    y: 28.262196,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 600,
      fontStretch: "normal",
      fontSize: "5.643188px",
      fontFamily: "Crossten",
      InkscapeFontSpecification: "'Crossten Semi-Bold'",
      fill: "#061e37",
      fillOpacity: 1,
      strokeWidth: 0.7053985
    }
  }, "Device")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeDeviceKey);
export default __webpack_public_path__ + "static/media/node-device-key.8dbe388cefb4c81083ae58a8191f42f6.svg";
export { ForwardRef as ReactComponent };